export const IndicatorSeparator = () => null;
